<script setup lang="ts">

const TITLE = 'About NFT';
const EMPTY_MESSAGE = 'About NFT empty';

const { description = '', isLoading } = defineProps<
    {
        isLoading?: boolean;
        description?: AppWTFNft['description'];
        initialVisibility?: boolean;
    }>();

</script>

<template>
  <TokenDropPanel :title="TITLE"
                  :initial-visibility="initialVisibility">
    <div v-if="description"
         class="display-flex align-items-center justify-center flex-column">
      <template v-if="isLoading">
        <p v-for="i in Array(3)"
           :key="i"
           class="text-500-default text-color-secondary align-self-stretch pt-2">
          <SkeletonMain class="about_skeleton" />
        </p>
      </template>
      <template v-else-if="description">
        <Markdown :inline="false"
                  :source="description"
                  :unsafe="true"
                  class="text-500-default text-color-secondary align-self-stretch"
                  tag="div"
        />
      </template>
    </div>
    <div v-else
         class="display-flex align-items-center justify-center flex-column">
      <IconMain icon="air"
                :size="40"
      />
      <p>{{EMPTY_MESSAGE}}</p>
    </div>
  </TokenDropPanel>
</template>
<style scoped lang="scss">
.about_skeleton {
  display: block;
  flex: 1;
  min-width: 100%;
  height: 17px;
}
</style>
